module.exports = __webpack_public_path__ + "static/media/GroupDefaultIcon.3afc6e14.svg";